import React from "react";
import { Helmet } from "react-helmet";

const SITE_URL = "https://www.mompomasswines.com";
const DEFAULT_IMAGE = `${SITE_URL}/mompo-logo.svg`;

function SEO({
  title,
  description,
  path,
  alternatePath,
  language = "en",
  type = "website",
  schema,
  noindex = false,
}) {
  const canonicalUrl = `${SITE_URL}${path}`;
  const alternateUrl = alternatePath
    ? `${SITE_URL}${alternatePath}`
    : undefined;
  const alternateLanguage = language === "es" ? "en" : "es";

  return (
    <Helmet htmlAttributes={{ lang: language }}>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta
        name="robots"
        content={noindex ? "noindex, nofollow" : "index, follow"}
      />

      {!noindex && <link rel="canonical" href={canonicalUrl} />}
      {!noindex && alternateUrl && (
        <link
          rel="alternate"
          hrefLang={language}
          href={canonicalUrl}
        />
      )}
      {!noindex && alternateUrl && (
        <link
          rel="alternate"
          hrefLang={alternateLanguage}
          href={alternateUrl}
        />
      )}
      {!noindex && alternateUrl && (
        <link
          rel="alternate"
          hrefLang="x-default"
          href={language === "en" ? canonicalUrl : alternateUrl}
        />
      )}

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={DEFAULT_IMAGE} />
      <meta property="og:image:alt" content="Mompó Mass Wines logo" />
      <meta property="og:site_name" content="Mompó Mass Wines" />
      <meta
        property="og:locale"
        content={language === "es" ? "es_ES" : "en_US"}
      />
      <meta
        property="og:locale:alternate"
        content={language === "es" ? "en_US" : "es_ES"}
      />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={DEFAULT_IMAGE} />

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}

export default SEO;
